/* ====================================
   Electric Cloud — Custom Cart Drawer
   Javvy-inspired, EC-branded (site-wide)
   ==================================== */
(function() {
  'use strict';

  // ============================================
  // CONFIGURATION
  // ============================================

  var RETAIL_PRICE = 5.99;
  var SUB_DISCOUNT_PCT = 20; // default selling plan discount %

  var DISCOUNT_TIERS = [
    { minPacks: 1, maxPacks: 1, pricePerCan: 5.40, percentOff: 10 },
    { minPacks: 2, maxPacks: 2, pricePerCan: 4.80, percentOff: 20 },
    { minPacks: 3, maxPacks: 3, pricePerCan: 4.38, percentOff: 27 },
    { minPacks: 4, maxPacks: 4, pricePerCan: 4.08, percentOff: 32 },
    { minPacks: 5, maxPacks: 8, pricePerCan: 3.90, percentOff: 35 }
  ];

  var DISCOUNT_CODES = {
    6: 'BUNDLE_EC_SB6', 12: 'BUNDLE_EC_SB12', 18: 'BUNDLE_EC_SB18',
    24: 'BUNDLE_EC_SB24', 30: 'BUNDLE_EC_SB30', 36: 'BUNDLE_EC_SB36',
    42: 'BUNDLE_EC_SB42', 48: 'BUNDLE_EC_SB48'
  };

  // First-order discount % for single-flavor drink packs (selling plan is 20%, discount code adds the rest)
  var FIRST_ORDER_DISCOUNTS = { 6: 10, 12: 20, 18: 27, 24: 32, 30: 35 };

  // Variant ID → flavor name map for bundle children
  var FLAVOR_NAMES = {
    '47457909932224': 'Blue Raspberry', '47457909899456': 'Cotton Candy',
    '47457909735616': 'Juicy Peach', '47457909833920': 'Sour Watermelon',
    '47457910030528': 'Watermelon Mint', '47457909276864': 'Strawberry Guava',
    '47457799700672': 'Mango Limeade', '48149384396992': 'Cherry Limeade'
  };

  // Bundle parent variants + selling plans for subscription conversion
  var BUNDLE_PACK_OPTIONS = {
    6:  { parentVariantId: 47458107031744, sellingPlan: 3489890496 },
    12: { parentVariantId: 47457933885632, sellingPlan: 3489759424 },
    18: { parentVariantId: 47457933885632, sellingPlan: 3489759424 },
    24: { parentVariantId: 47457933885632, sellingPlan: 3489759424 },
    30: { parentVariantId: 47457933885632, sellingPlan: 3489759424 },
    36: { parentVariantId: 47457933885632, sellingPlan: 3489759424 },
    42: { parentVariantId: 47457933885632, sellingPlan: 3489759424 },
    48: { parentVariantId: 47457933885632, sellingPlan: 3489759424 }
  };

  // Carousel upsell products (gummies)
  var UPSELL_PRODUCTS = [
    { variantId: 44042671718592, title: 'Anytime CBD Gummies', price: 29.00, image: 'https://cdn.shopify.com/s/files/1/0539/6398/0992/files/Anytimev2.png?v=1771087024' },
    { variantId: 43274390896832, title: 'Relax Gummies', price: 29.00, image: 'https://cdn.shopify.com/s/files/1/0539/6398/0992/files/Relax_ccece947-b233-4912-9e02-6aafe746671a.png?v=1771086975' },
    { variantId: 43452074950848, title: 'Awake Gummies', price: 29.00, image: 'https://cdn.shopify.com/s/files/1/0539/6398/0992/files/Awake_29bae530-f4d4-4f04-b27f-a8bf2ec8533c.png?v=1771086975' },
    { variantId: 43452302753984, title: 'Immunity Gummies', price: 29.00, image: 'https://cdn.shopify.com/s/files/1/0539/6398/0992/files/Immunity_773dbd9f-1453-4d21-a42f-a1ee3d797f0d.png?v=1771086975' }
  ];

  // ============================================
  // HELPERS
  // ============================================

  var _dummy = document.createElement('div');
  function $(id) { return document.getElementById(id) || _dummy; }

  function getShoppingNowCount() {
    var KEY = 'ec_shopping_now';
    var INTERVAL = 10 * 60 * 1000; // 10 minutes
    var MIN = 150, MAX = 599, DRIFT = 0.2;
    try {
      var stored = JSON.parse(localStorage.getItem(KEY));
      if (stored && Date.now() - stored.t < INTERVAL) return stored.n;
      // Time to update — drift ±20% from previous value
      if (stored && stored.n) {
        var lo = Math.max(MIN, Math.round(stored.n * (1 - DRIFT)));
        var hi = Math.min(MAX, Math.round(stored.n * (1 + DRIFT)));
        var n = Math.floor(Math.random() * (hi - lo + 1)) + lo;
        localStorage.setItem(KEY, JSON.stringify({ n: n, t: Date.now() }));
        return n;
      }
    } catch(e) {}
    // First time — seed random
    var seed = Math.floor(Math.random() * (MAX - MIN + 1)) + MIN;
    localStorage.setItem(KEY, JSON.stringify({ n: seed, t: Date.now() }));
    return seed;
  }

  function getTier(packs) {
    for (var i = 0; i < DISCOUNT_TIERS.length; i++) {
      var t = DISCOUNT_TIERS[i];
      if (packs >= t.minPacks && packs <= t.maxPacks) return t;
    }
    return DISCOUNT_TIERS[DISCOUNT_TIERS.length - 1];
  }

  function getDiscountForCans(totalCans) {
    var validSizes = [48, 42, 36, 30, 24, 18, 12, 6];
    for (var i = 0; i < validSizes.length; i++) {
      if (totalCans >= validSizes[i]) return DISCOUNT_CODES[validSizes[i]] || '';
    }
    return '';
  }

  // Bundle flavor variant IDs (Custom Mixed Bundle product)
  var BUNDLE_FLAVOR_VARIANTS = [
    47457909932224, 47457909899456, 47457909735616, 47457909833920,
    47457910030528, 47457909276864, 47457799700672
  ];

  function getTotalBundleCans(cart) {
    var totalCans = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var props = item.properties || {};
      // Count subscription bundle children (with _bundle_id property)
      if (props._bundle_id && props._bundle_parent !== 'true' && props._bundle_parent !== true && props._otp_bundle !== 'true') {
        totalCans += item.quantity * 6;
      }
      // Also count loose bundle flavor variants (e.g. from cart permalink / abandoned cart recovery)
      else if (!props._bundle_id && BUNDLE_FLAVOR_VARIANTS.indexOf(item.variant_id) !== -1) {
        totalCans += item.quantity * 6;
      }
    }
    return totalCans;
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function(r) { return r.json(); });
  }

  // Product JSON cache for selling plan lookups
  var productCache = {};
  function fetchProduct(url) {
    var clean = url.split('?')[0];
    if (productCache[clean]) return Promise.resolve(productCache[clean]);
    return fetch(clean + '.js').then(function(r) { return r.json(); }).then(function(p) {
      productCache[clean] = p;
      return p;
    });
  }

  function getFirstSellingPlanId(product) {
    var g = product.selling_plan_groups;
    if (!g || !g.length) return null;
    var plans = g[0].selling_plans;
    if (!plans || !plans.length) return null;
    // Prefer 30-day plan
    for (var i = 0; i < plans.length; i++) {
      if (plans[i].name && plans[i].name.indexOf('30') !== -1) return plans[i].id;
    }
    return plans[0].id;
  }

  // Get cart variant IDs for filtering upsell
  function getCartVariantIds(cart) {
    var ids = {};
    for (var i = 0; i < cart.items.length; i++) {
      ids[cart.items[i].variant_id] = true;
    }
    return ids;
  }

  // Check if item title looks like a gummy
  function isGummyTitle(title) {
    return (title || '').toLowerCase().indexOf('gumm') !== -1;
  }

  // ============================================
  // CART ANALYSIS
  // ============================================

  function analyzeCart(cart) {
    var hasOneTimeConvertible = false;
    var hasSubscription = false;
    var hasBundles = false;    // subscription bundles
    var hasOtpBundles = false; // one-time purchase bundles
    var totalBundleCans = getTotalBundleCans(cart);
    var bestDiscountPct = 0; // highest discount % found in cart

    // Track totals
    var onetimeTotal = 0; // cents — what one-time items cost now
    var subEstTotal = 0;  // cents — estimated subscription total for those items
    var totalOnetimeCans = 0; // total cans from one-time drink items

    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var props = item.properties || {};

      if (props._bundle_id) {
        if (props._otp_bundle === 'true') {
          hasOtpBundles = true;
          // Count OTP bundle cans for one-time total
          if (props._bundle_parent !== 'true' && props._bundle_parent !== true) {
            onetimeTotal += item.final_line_price;
            totalOnetimeCans += item.quantity * 6;
          }
        } else {
          hasBundles = true;
        }
        continue;
      }

      if (item.selling_plan_allocation) {
        hasSubscription = true;
        // Check first-order discount from pack size (includes discount code applied at checkout)
        var packMatch = (item.variant_title || '').match(/(\d+)\s*Pack/i);
        var packSize = packMatch ? parseInt(packMatch[1]) : 0;
        if (packSize && FIRST_ORDER_DISCOUNTS[packSize]) {
          var pct = FIRST_ORDER_DISCOUNTS[packSize];
          if (pct > bestDiscountPct) bestDiscountPct = pct;
        } else {
          // Fallback: calculate from selling plan data
          var spa = item.selling_plan_allocation;
          if (spa.compare_at_price && spa.per_delivery_price && spa.compare_at_price > 0) {
            var pct = Math.round((1 - spa.per_delivery_price / spa.compare_at_price) * 100);
            if (pct > bestDiscountPct) bestDiscountPct = pct;
          }
        }
        continue;
      }

      // One-time item
      hasOneTimeConvertible = true;
      onetimeTotal += item.final_line_price;
      // Count total cans from one-time drink items
      var otPackMatch = (item.variant_title || '').match(/(\d+)\s*Pack/i);
      var otPackSize = otPackMatch ? parseInt(otPackMatch[1]) : 0;
      if (otPackSize) {
        totalOnetimeCans += otPackSize * item.quantity;
      }
    }

    // Best discount based on total one-time cans (as if they built a bundle)
    if (totalOnetimeCans > 0) {
      var otPacks = Math.floor(totalOnetimeCans / 6);
      if (otPacks > 0) {
        var otTier = getTier(otPacks);
        if (otTier && otTier.percentOff > bestDiscountPct) bestDiscountPct = otTier.percentOff;
      }
    }

    // Bundle tier discount — check the highest tier in cart
    if (hasBundles) {
      var bundlePacks = totalBundleCans / 6;
      var bTier = getTier(bundlePacks);
      if (bTier && bTier.percentOff > bestDiscountPct) bestDiscountPct = bTier.percentOff;
    }

    // Estimate subscription total using tier discount for total cans
    var otTierPct = 0;
    if (totalOnetimeCans > 0) {
      var estPacks = Math.floor(totalOnetimeCans / 6);
      if (estPacks > 0) {
        var estTier = getTier(estPacks);
        if (estTier) otTierPct = estTier.percentOff;
      }
    }
    for (var j = 0; j < cart.items.length; j++) {
      var oti = cart.items[j];
      var otProps = oti.properties || {};
      // Include standalone one-time items AND OTP bundle children
      var isOtpChild = otProps._bundle_id && otProps._otp_bundle === 'true' && otProps._bundle_parent !== 'true';
      if ((!otProps._bundle_id && !oti.selling_plan_allocation) || isOtpChild) {
        var estPct = otTierPct > 0 ? otTierPct : SUB_DISCOUNT_PCT;
        subEstTotal += Math.round(oti.final_line_price * (1 - estPct / 100));
      }
    }

    // Dual mode when all items are one-time (including OTP bundles) — no subs, no sub bundles
    var showDual = (hasOneTimeConvertible || hasOtpBundles) && !hasSubscription && !hasBundles;

    return {
      hasOneTimeConvertible: hasOneTimeConvertible,
      hasSubscription: hasSubscription,
      showDual: showDual,
      hasBundles: hasBundles,
      hasOtpBundles: hasOtpBundles,
      totalBundleCans: totalBundleCans,
      onetimeTotal: onetimeTotal,
      subEstTotal: subEstTotal,
      estimatedSavings: onetimeTotal - subEstTotal,
      bestDiscountPct: bestDiscountPct > 0 ? bestDiscountPct : SUB_DISCOUNT_PCT
    };
  }

  // ============================================
  // DRAWER OPEN / CLOSE
  // ============================================

  function openDrawer() {
    render();
    var ov = $('cd-overlay'); if (ov) ov.classList.add('cd-overlay--open');
    var dr = $('cd-drawer'); if (dr) dr.classList.add('cd-drawer--open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    var ov = $('cd-overlay'); if (ov) ov.classList.remove('cd-overlay--open');
    var dr = $('cd-drawer'); if (dr) dr.classList.remove('cd-drawer--open');
    document.body.style.overflow = '';
  }

  // ============================================
  // RENDER
  // ============================================

  function render() {
    fetchCart().then(function(cart) {
      // If only free gifts remain (no paid items), clear them out
      if (cart.items && cart.items.length > 0 && cart.items.every(function(i) { return i.final_line_price === 0; })) {
        return fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
          .then(function() { return fetchCart(); })
          .then(function(cleared) { renderCart(cleared); });
      }
      renderCart(cart);
    }).catch(function() {
      var b = $('cd-body'); if (b) b.innerHTML = '<div class="cd-empty">Failed to load cart</div>';
      var f = $('cd-footer'); if (f) f.style.display = 'none';
      var bn = $('cd-banner'); if (bn) bn.style.display = 'none';
      var cw = $('cd-carousel-wrap'); if (cw) cw.style.display = 'none';
    });
  }

  function renderCart(cart) {
    // Stock Protection: remove OOS items before rendering
    if (window.EC_STOCK_PROTECTION && window.EC_STOCK_PROTECTION.ready && cart.items) {
      var sp = window.EC_STOCK_PROTECTION;
      var oosKeys = [];
      cart.items.forEach(function(item) {
        if (sp.protectedIds[String(item.variant_id)] || (item.handle && sp.protectedSlugs[item.handle])) {
          oosKeys.push(item.key);
        }
      });
      if (oosKeys.length > 0) {
        // Remove OOS items from cart and re-fetch
        Promise.all(oosKeys.map(function(key) {
          return fetch('/cart/change.js', { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({id: key, quantity: 0}) });
        })).then(function() {
          fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cleaned) { renderCart(cleaned); });
        });
        // Show toast
        var t = document.getElementById('ec-oos-toast');
        if (!t) { t = document.createElement('div'); t.id = 'ec-oos-toast'; document.body.appendChild(t); }
        t.textContent = 'Sold out item removed from cart';
        t.style.cssText = 'position:fixed;bottom:24px;left:50%;transform:translateX(-50%);background:#1a1a2e;color:#fff;padding:14px 28px;border-radius:10px;font-size:14px;font-weight:600;z-index:99999;box-shadow:0 4px 20px rgba(0,0,0,0.15);font-family:Helvetica,sans-serif;';
        setTimeout(function(){t.style.opacity='0';setTimeout(function(){t.remove();},300);},3000);
        return; // Don't render yet — wait for cleaned cart
      }
    }
    var body = $('cd-body');
    var footer = $('cd-footer');
    var banner = $('cd-banner');

    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = '<div class="cd-empty">'
        + '<p class="cd-empty__heading">Your cart is empty</p>'
        + '<p class="cd-empty__sub">Let\'s fill it up with deliciousness.</p>'
        + '<div class="cd-empty__grid">'
        + '<a href="/collections/all#drinks" class="cd-empty__card">'
        + '<img src="https://cdn.shopify.com/s/files/1/0539/6398/0992/files/Sour-Watermelon.jpg?v=1769615809" alt="CBD Drinks" class="cd-empty__card-img">'
        + '<span class="cd-empty__card-label">Shop Drinks</span></a>'
        + '<a href="/collections/all#gummies" class="cd-empty__card">'
        + '<img src="https://cdn.shopify.com/s/files/1/0539/6398/0992/files/Relax-Watermelon-Lay.jpg?v=1771027203" alt="CBD Gummies" class="cd-empty__card-img">'
        + '<span class="cd-empty__card-label">Shop Gummies</span></a>'
        + '<a href="/products/custom-mixed-bundle" class="cd-empty__card">'
        + '<img src="https://cdn.shopify.com/s/files/1/0539/6398/0992/files/ElectricCloudFeb2023-27_a928b0ee-4b2a-4b43-b213-3848e6ec1eaa.jpg?v=1736549852" alt="Build Your Pack" class="cd-empty__card-img">'
        + '<span class="cd-empty__card-label">Build Your Pack</span></a>'
        + '<a href="/pages/quiz" class="cd-empty__card">'
        + '<img src="https://cdn.shopify.com/s/files/1/0539/6398/0992/files/CEitBhcu4p3r6hmcPCYZj.webp?v=1770830654" alt="Flavor Quiz" class="cd-empty__card-img">'
        + '<span class="cd-empty__card-label">Take the Quiz</span></a>'
        + '</div></div>';
      footer.style.display = '';
      banner.style.display = 'none';
      $('cd-carousel-wrap').style.display = 'none';
      $('cd-count').textContent = '0';
      // Show empty footer with shop all button
      $('cd-dual-checkout').style.display = 'none';
      $('cd-single-checkout').style.display = '';
      $('cd-subtotal-row').style.display = 'none';
      var chk = $('cd-checkout');
      if (chk) { chk.onclick = function(e) { e.preventDefault(); window.location.href = '/collections/all'; }; }
      var chkSpan = chk && chk.querySelector('span');
      if (chkSpan) chkSpan.textContent = 'SHOP ALL PRODUCTS';
      // Hide trust stars, keep guarantee, show shopping now
      var cdTrust = document.querySelector('.cd-trust'); if (cdTrust) cdTrust.style.display = 'none';
      var cdGuarantee = document.querySelector('.cd-guarantee'); if (cdGuarantee) cdGuarantee.style.display = '';
      var shopNow = document.querySelector('.cd-shopping-now');
      if (!shopNow) {
        shopNow = document.createElement('div');
        shopNow.className = 'cd-shopping-now';
      }
      // Insert above the Shop All Products button (cd-single-checkout)
      var singleCheckoutEl = $('cd-single-checkout');
      if (singleCheckoutEl && singleCheckoutEl.parentNode) {
        singleCheckoutEl.parentNode.insertBefore(shopNow, singleCheckoutEl);
      } else {
        footer.appendChild(shopNow);
      }
      var count = getShoppingNowCount();
      shopNow.innerHTML = '<span class="cd-shopping-now__dot"></span> <b>' + count + '</b> people are shopping now';
      shopNow.style.display = '';
      updateBadge(0);
      return;
    }

    var analysis = analyzeCart(cart);

    // ---- Subscription banner ----
    if (analysis.showDual) {
      // All one-time (including OTP bundles) — upsell subscription
      banner.className = 'cd-banner cd-banner--upsell';
      banner.innerHTML = 'You can get up to <b>' + analysis.bestDiscountPct + '% OFF</b> today <b>with subscription</b>';
      banner.style.display = '';
    } else if (analysis.hasSubscription || analysis.hasBundles) {
      // Has subscription or bundle items — congrats
      banner.className = 'cd-banner cd-banner--congrats';
      banner.innerHTML = '<b>Congrats!</b> You\'re saving <b>' + analysis.bestDiscountPct + '% OFF</b> on your first subscription';
      banner.style.display = '';
    } else {
      banner.style.display = 'none';
    }

    // ---- Group items ----
    var bundles = {};
    var standalone = [];

    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var props = item.properties || {};
      if (props._bundle_id) {
        if (!bundles[props._bundle_id]) bundles[props._bundle_id] = { parent: null, children: [] };
        if (props._bundle_parent === 'true' || props._bundle_parent === true) {
          bundles[props._bundle_id].parent = item;
        } else {
          bundles[props._bundle_id].children.push(item);
        }
      } else {
        standalone.push(item);
      }
    }

    var html = '';
    var displayCount = 0;
    var customSubtotal = 0;

    // ---- Render bundles ----
    var bundleIds = Object.keys(bundles);
    for (var b = 0; b < bundleIds.length; b++) {
      var bundleId = bundleIds[b];
      var bundle = bundles[bundleId];
      var isOtp = !bundle.parent; // One-time purchase bundles have no parent item

      var packProp = '';
      if (!isOtp) {
        var parent = bundle.parent;
        packProp = (parent.properties && parent.properties.Pack) || '';
      }

      var firstChild = bundle.children[0];
      var img = firstChild ? firstChild.image : '';

      var bundleCans = 0;
      for (var c = 0; c < bundle.children.length; c++) bundleCans += bundle.children[c].quantity * 6;
      var bundlePacks = bundleCans / 6;

      if (isOtp) {
        packProp = bundlePacks + (bundlePacks === 1 ? ' six-pack' : ' six-packs');
      }

      var bTier = getTier(bundlePacks);
      var discountPrice = isOtp ? (RETAIL_PRICE * bundleCans) : (bTier ? (bTier.pricePerCan * bundleCans) : (RETAIL_PRICE * bundleCans));
      var bundleRetail = RETAIL_PRICE * bundleCans;
      customSubtotal += discountPrice;

      var flavorParts = [];
      for (var fc = 0; fc < bundle.children.length; fc++) {
        var ch = bundle.children[fc];
        flavorParts.push(ch.quantity + '\u00d7 ' + (FLAVOR_NAMES[String(ch.variant_id)] || ch.variant_title || ch.product_title || ch.title));
      }

      var bundleSavings = bundleRetail - discountPrice;

      html += '<div class="cd-item" data-bundle-id="' + bundleId + '">'
        + '<img class="cd-item__img" src="' + img + '" alt="Bundle">'
        + '<div class="cd-item__info">'
        + '<p class="cd-item__title">Custom Bundle</p>'
        + '<p class="cd-item__delivery">' + (isOtp ? 'One-time purchase' : 'Delivery every 30 days') + '</p>'
        + '<p class="cd-item__subtitle">' + packProp + '</p>'
        + '<p class="cd-item__flavors">' + flavorParts.join(', ') + '</p>'
        + '<div class="cd-item__price-row">'
        + (bundleSavings > 0.01 ? '<span class="cd-item__compare">$' + bundleRetail.toFixed(2) + '</span>' : '')
        + '<span class="cd-item__price">$' + discountPrice.toFixed(2) + '</span>'
        + (bundleSavings > 0.01 ? '<span class="cd-item__savings-badge">$' + bundleSavings.toFixed(2) + ' off</span>' : '')
        + '</div>'
        + (isOtp ? '<div class="cd-item__sub-eligible"><svg viewBox="0 0 20 20" fill="#058c8c"><path d="M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm-1 15l-5-5 1.41-1.41L9 12.17l6.59-6.59L17 7l-8 8z"/></svg>Subscribe &amp; Save Eligible</div>' : '')
        + '</div>'
        + '<button class="cd-item__remove" data-remove-bundle="' + bundleId + '" title="Remove bundle">&times;</button>'
        + '</div>';
      displayCount++;
    }

    // ---- Render standalone items ----
    for (var s = 0; s < standalone.length; s++) {
      var si = standalone[s];
      var isSub = !!si.selling_plan_allocation;
      var deliveryText = '';
      var priceRow = '';

      if (isSub) {
        // Subscription item — use selling plan allocation prices (immune to lingering discount codes)
        var spa = si.selling_plan_allocation;
        var spName = (spa.selling_plan && spa.selling_plan.name) || 'Delivery every 30 days';
        deliveryText = spName;
        var compareLinePrice = (spa.compare_at_price * si.quantity) / 100;

        // Apply first-order discount if available (selling plan only gives 20%, discount code adds the rest at checkout)
        var packMatch = (si.variant_title || '').match(/(\d+)\s*Pack/i);
        var packSize = packMatch ? parseInt(packMatch[1]) : 0;
        var firstOrderPct = packSize && FIRST_ORDER_DISCOUNTS[packSize] ? FIRST_ORDER_DISCOUNTS[packSize] : 0;
        var subLinePrice;
        if (firstOrderPct > 0 && compareLinePrice > 0) {
          subLinePrice = Math.round(compareLinePrice * (1 - firstOrderPct / 100) * 100) / 100;
        } else {
          subLinePrice = (spa.per_delivery_price * si.quantity) / 100;
        }
        var itemSavings = compareLinePrice - subLinePrice;
        customSubtotal += subLinePrice;

        priceRow = '<div class="cd-item__price-row">';
        if (itemSavings > 0.01) {
          priceRow += '<span class="cd-item__compare">$' + compareLinePrice.toFixed(2) + '</span>';
        }
        priceRow += '<span class="cd-item__price">$' + subLinePrice.toFixed(2) + '</span>';
        if (itemSavings > 0.01) {
          priceRow += '<span class="cd-item__savings-badge">$' + itemSavings.toFixed(2) + ' off</span>';
        }
        priceRow += '</div>';
      } else {
        // One-time item
        var linePrice = si.final_line_price / 100;
        customSubtotal += linePrice;
        deliveryText = 'One-time purchase';
        priceRow = '<div class="cd-item__price-row">'
          + '<span class="cd-item__price">$' + linePrice.toFixed(2) + '</span>'
          + '</div>';
      }

      var subEligible = '';
      if (!isSub) {
        subEligible = '<div class="cd-item__sub-eligible">'
          + '<svg viewBox="0 0 20 20" fill="#058c8c"><path d="M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm-1 15l-5-5 1.41-1.41L9 12.17l6.59-6.59L17 7l-8 8z"/></svg>'
          + 'Subscribe &amp; Save Eligible</div>';
      }

      // Free gift detection — $0 items shown without quantity controls
      var isFreeGift = si.final_line_price === 0;

      html += '<div class="cd-item' + (isFreeGift ? ' cd-item--gift' : '') + '">'
        + '<img class="cd-item__img" src="' + si.image + '" alt="' + (si.product_title || si.title) + '">'
        + '<div class="cd-item__info">'
        + '<p class="cd-item__title">' + si.product_title + (isFreeGift ? ' <span class="cd-item__gift-badge">FREE</span>' : '') + '</p>'
        + (si.variant_title && si.variant_title !== 'Default Title' ? '<p class="cd-item__variant">' + si.variant_title + '</p>' : '')
        + '<p class="cd-item__delivery">' + (isFreeGift ? 'Free gift with your order' : deliveryText) + '</p>'
        + (isFreeGift ? '' : priceRow)
        + (isFreeGift ? '' : subEligible)
        + '</div>'
        + (isFreeGift ? '' : '<div class="cd-item__right">'
        + '<div class="cd-qty" data-item-key="' + si.key + '">'
        + '<button class="cd-qty__btn" data-qty-change="-1">&#8722;</button>'
        + '<span class="cd-qty__val">' + si.quantity + '</span>'
        + '<button class="cd-qty__btn" data-qty-change="1">+</button>'
        + '</div>'
        + '</div>')
        + '</div>';
      displayCount++;
    }

    body.innerHTML = html;

    // ---- Upsell Carousel (pinned above footer) ----
    var carouselWrap = $('cd-carousel-wrap');
    var cartVariants = getCartVariantIds(cart);
    var upsellItems = [];
    for (var u = 0; u < UPSELL_PRODUCTS.length; u++) {
      if (!cartVariants[UPSELL_PRODUCTS[u].variantId]) upsellItems.push(UPSELL_PRODUCTS[u]);
    }

    if (upsellItems.length > 0) {
      function cardHtml(item, index, isClone) {
        return '<div class="cd-carousel__card' + (isClone ? ' cd-clone' : '') + '" data-card-index="' + index + '">'
          + '<img class="cd-carousel__card-img" src="' + item.image + '" alt="' + item.title + '">'
          + '<div class="cd-carousel__card-info">'
          + '<p class="cd-carousel__card-name">' + item.title + '</p>'
          + '<p class="cd-carousel__card-meta">One-time add-on</p>'
          + '<p class="cd-carousel__card-price">$' + item.price.toFixed(2) + '</p>'
          + '</div>'
          + '<button class="cd-carousel__card-add" data-upsell-variant="' + item.variantId + '">Add +</button>'
          + '</div>';
      }

      var carHtml = '<div class="cd-carousel">'
        + '<p class="cd-carousel__heading">Looking for an extra lift?</p>'
        + '<div class="cd-carousel__track" id="cd-carousel-track">';

      // Infinite scroll: clone set + real set + clone set
      if (upsellItems.length > 1) {
        for (var ci = 0; ci < upsellItems.length; ci++) carHtml += cardHtml(upsellItems[ci], ci, true);
      }
      for (var ci = 0; ci < upsellItems.length; ci++) carHtml += cardHtml(upsellItems[ci], ci, false);
      if (upsellItems.length > 1) {
        for (var ci = 0; ci < upsellItems.length; ci++) carHtml += cardHtml(upsellItems[ci], ci, true);
      }

      carHtml += '</div>'; // track

      // Dot indicators
      if (upsellItems.length > 1) {
        carHtml += '<div class="cd-carousel__dots" id="cd-carousel-dots">';
        for (var d = 0; d < upsellItems.length; d++) {
          carHtml += '<button class="cd-carousel__dot' + (d === 0 ? ' cd-carousel__dot--active' : '') + '" data-dot-index="' + d + '"></button>';
        }
        carHtml += '</div>';
      }

      carHtml += '</div>'; // carousel
      carouselWrap.innerHTML = carHtml;
      carouselWrap.style.display = '';
    } else {
      carouselWrap.innerHTML = '';
      carouselWrap.style.display = 'none';
    }
    footer.style.display = '';
    // Restore trust / hide shopping-now when cart has items
    var cdTrust2 = document.querySelector('.cd-trust'); if (cdTrust2) cdTrust2.style.display = '';
    var cdGuarantee2 = document.querySelector('.cd-guarantee'); if (cdGuarantee2) cdGuarantee2.style.display = '';
    var shopNowEl = document.querySelector('.cd-shopping-now');
    if (shopNowEl) shopNowEl.style.display = 'none';

    // ---- Count badge ----
    $('cd-count').textContent = displayCount;

    // ---- Footer mode ----
    var dualCheckout = $('cd-dual-checkout');
    var singleCheckout = $('cd-single-checkout');

    if (analysis.showDual) {
      // Dual mode — all items are one-time, offer subscription conversion
      dualCheckout.style.display = '';
      singleCheckout.style.display = 'none';
      var cdG3 = document.querySelector('.cd-guarantee'); if (cdG3) cdG3.style.display = 'none';

      // Pill
      $('cd-offer-pill').textContent = 'GET ' + analysis.bestDiscountPct + '% OFF TODAY';

      // Subscription price estimate
      $('cd-sub-price').textContent = '$' + (analysis.subEstTotal / 100).toFixed(2);

      // Dynamic free shipping text — $75+ = every order, under $75 = first order only
      var shippingEl = $('cd-shipping-text');
      if (shippingEl) {
        var subDollars = analysis.subEstTotal / 100;
        shippingEl.textContent = subDollars >= 75 ? 'every order' : 'on first order';
      }

      // One-time price
      $('cd-otp-price').textContent = '$' + customSubtotal.toFixed(2);
    } else {
      // Single mode — has subs, bundles, or mixed cart
      dualCheckout.style.display = 'none';
      singleCheckout.style.display = '';
      var cdG4 = document.querySelector('.cd-guarantee'); if (cdG4) cdG4.style.display = '';

      // Restore checkout button (may have been overridden by empty state)
      var sr = $('cd-subtotal-row'); if (sr) sr.style.display = '';
      var chk2 = $('cd-checkout');
      if (chk2) { chk2.onclick = null; }
      var chk2Span = chk2 && chk2.querySelector('span');
      if (chk2Span) chk2Span.textContent = 'PROCEED TO CHECKOUT';

      // Subtotal row
      var itemCount = displayCount;
      $('cd-subtotal-label').textContent = 'Subtotal: ' + itemCount + (itemCount === 1 ? ' item' : ' items');
      $('cd-subtotal-price').textContent = '$' + customSubtotal.toFixed(2);

      // Compare price & savings (sum of all compare_at prices)
      var compareTotal = 0;
      for (var ci2 = 0; ci2 < cart.items.length; ci2++) {
        var cItem = cart.items[ci2];
        if (cItem.properties && cItem.properties._bundle_parent) continue; // skip $0 parent
        if (cItem.selling_plan_allocation && cItem.selling_plan_allocation.compare_at_price) {
          compareTotal += (cItem.selling_plan_allocation.compare_at_price * cItem.quantity) / 100;
        } else if (cItem.properties && cItem.properties._bundle_id && !cItem.properties._bundle_parent) {
          // Bundle child — retail price
          compareTotal += cItem.quantity * RETAIL_PRICE * 6;
        } else {
          compareTotal += cItem.final_line_price / 100;
        }
      }
      var totalSavings = compareTotal - customSubtotal;
      if (totalSavings > 0.01) {
        $('cd-subtotal-compare').textContent = '$' + compareTotal.toFixed(2);
        $('cd-subtotal-savings').textContent = '$' + totalSavings.toFixed(2) + ' OFF';
      } else {
        $('cd-subtotal-compare').textContent = '';
        $('cd-subtotal-savings').textContent = '';
      }
    }

    // ---- Badge ----
    updateBadge(cart.item_count);

    // ---- Event handlers ----
    attachItemHandlers(body);
    attachItemHandlers(carouselWrap);

    // ---- Carousel scroll dots ----
    initCarouselDots();
  }

  // ============================================
  // CAROUSEL — INFINITE LOOP + SNAP-TO-CARD
  // ============================================

  function initCarouselDots() {
    var track = $('cd-carousel-track');
    var dotsContainer = $('cd-carousel-dots');
    if (!track) return;

    var realCards = track.querySelectorAll('.cd-carousel__card:not(.cd-clone)');
    var realCount = realCards.length;
    if (realCount <= 1) return;

    var dots = dotsContainer ? dotsContainer.querySelectorAll('.cd-carousel__dot') : [];
    var gap = 12;
    function getStep() { return realCards[0].offsetWidth + gap; }

    // Position at real set (clones before = realCount cards)
    track.scrollLeft = realCount * getStep();
    var currentIndex = 0;

    function updateDots() {
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('cd-carousel__dot--active', i === currentIndex);
      }
    }

    function detectIndex() {
      var step = getStep();
      var offset = track.scrollLeft - realCount * step;
      currentIndex = ((Math.round(offset / step) % realCount) + realCount) % realCount;
      updateDots();
    }

    // Seamless loop — jump to real set when in clone territory
    var looping = false;
    function checkLoop() {
      if (looping) return;
      var s = track.scrollLeft, step = getStep();
      var realStart = realCount * step, realEnd = realStart + realCount * step;
      if (s < step * 0.5) { looping = true; track.scrollLeft = s + realCount * step; looping = false; }
      else if (s >= realEnd - step * 0.5) { looping = true; track.scrollLeft = s - realCount * step; looping = false; }
    }

    track.addEventListener('scroll', function() { if (!looping) detectIndex(); });

    // Click dot to scroll
    for (var d = 0; d < dots.length; d++) {
      dots[d].addEventListener('click', function() {
        stopAnim();
        var idx = parseInt(this.getAttribute('data-dot-index'));
        var step = getStep();
        animateTo(realCount * step + idx * step);
      });
    }

    // Smooth animate to target with easeOutCubic
    var rafId = 0;
    function stopAnim() { if (rafId) { cancelAnimationFrame(rafId); rafId = 0; } }
    function animateTo(target) {
      stopAnim();
      var start = track.scrollLeft;
      var dist = target - start;
      if (Math.abs(dist) < 1) { track.scrollLeft = target; checkLoop(); detectIndex(); return; }
      var duration = Math.min(400, Math.max(200, Math.abs(dist) * 0.8));
      var t0 = performance.now();
      function tick(now) {
        var p = Math.min(1, (now - t0) / duration);
        // easeOutCubic
        var ease = 1 - Math.pow(1 - p, 3);
        track.scrollLeft = start + dist * ease;
        if (p < 1) { rafId = requestAnimationFrame(tick); }
        else { track.scrollLeft = target; checkLoop(); detectIndex(); }
      }
      rafId = requestAnimationFrame(tick);
    }

    // Mouse drag → on release, glide smoothly into nearest snap point
    var isDown = false, startX = 0, scrollStart = 0;
    var velX = 0, lastX = 0, lastTime = 0;

    track.addEventListener('mousedown', function(e) {
      if (e.target.closest('button')) return; // don't drag when clicking buttons
      stopAnim();
      isDown = true;
      startX = e.pageX; lastX = e.pageX;
      lastTime = Date.now();
      scrollStart = track.scrollLeft;
      velX = 0;
      track.classList.add('cd-dragging');
    });
    track.addEventListener('mousemove', function(e) {
      if (!isDown) return;
      e.preventDefault();
      var now = Date.now();
      var dx = e.pageX - lastX;
      var dt = now - lastTime;
      if (dt > 0) velX = dx / dt * 16;
      lastX = e.pageX; lastTime = now;
      track.scrollLeft = scrollStart - (e.pageX - startX);
    });
    function endDrag() {
      if (!isDown) return;
      isDown = false;
      track.classList.remove('cd-dragging');
      // Project where momentum would carry, then snap to nearest card
      var projected = track.scrollLeft - velX * 8;
      var step = getStep();
      var snapTarget = Math.round(projected / step) * step;
      animateTo(snapTarget);
    }
    track.addEventListener('mouseup', endDrag);
    track.addEventListener('mouseleave', function() { if (isDown) endDrag(); });

    // Touch drag → same as mouse: manually control scroll, snap on release
    var touchActive = false, touchStartX = 0, touchScrollStart = 0;
    track.addEventListener('touchstart', function(e) {
      if (e.target.closest('button')) return;
      stopAnim();
      touchActive = true;
      touchStartX = e.touches[0].pageX; lastX = touchStartX;
      lastTime = Date.now();
      touchScrollStart = track.scrollLeft;
      velX = 0;
    }, { passive: true });
    track.addEventListener('touchmove', function(e) {
      if (!touchActive) return;
      e.preventDefault();
      var tx = e.touches[0].pageX;
      var now = Date.now();
      var dt = now - lastTime;
      if (dt > 0) velX = (tx - lastX) / dt * 16;
      lastX = tx; lastTime = now;
      track.scrollLeft = touchScrollStart - (tx - touchStartX);
    }, { passive: false });
    track.addEventListener('touchend', function() {
      if (!touchActive) return;
      touchActive = false;
      var projected = track.scrollLeft - velX * 8;
      var step = getStep();
      var snapTarget = Math.round(projected / step) * step;
      animateTo(snapTarget);
    });
  }

  // ============================================
  // ITEM ACTIONS
  // ============================================

  function attachItemHandlers(body) {
    // Remove bundle
    var removeBtns = body.querySelectorAll('[data-remove-bundle]');
    for (var i = 0; i < removeBtns.length; i++) {
      removeBtns[i].addEventListener('click', function() {
        removeBundle(this.getAttribute('data-remove-bundle'));
      });
    }

    // Remove single item
    var removeKeys = body.querySelectorAll('[data-remove-key]');
    for (var j = 0; j < removeKeys.length; j++) {
      removeKeys[j].addEventListener('click', function() {
        removeItem(this.getAttribute('data-remove-key'));
      });
    }

    // Qty +/- buttons
    var qtyBtns = body.querySelectorAll('[data-qty-change]');
    for (var k = 0; k < qtyBtns.length; k++) {
      qtyBtns[k].addEventListener('click', function() {
        var container = this.closest('.cd-qty');
        var key = container.getAttribute('data-item-key');
        var currentQty = parseInt(container.querySelector('.cd-qty__val').textContent) || 0;
        var delta = parseInt(this.getAttribute('data-qty-change'));
        var newQty = Math.max(0, currentQty + delta);
        updateItemQty(key, newQty);
      });
    }

    // Upsell add buttons (carousel)
    var upsellBtns = body.querySelectorAll('[data-upsell-variant]');
    for (var u = 0; u < upsellBtns.length; u++) {
      upsellBtns[u].addEventListener('click', function() {
        var btn = this;
        var vid = parseInt(btn.getAttribute('data-upsell-variant'));
        btn.disabled = true;
        btn.textContent = 'Adding...';
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
        }).then(function(res) {
          if (!res.ok) throw new Error(res.status);
          return res.json();
        }).then(function() {
          render();
        }).catch(function(err) {
          console.error('Cart add failed:', err);
          btn.disabled = false;
          btn.textContent = 'Add +';
        });
      });
    }
  }

  function removeBundle(bundleId) {
    fetchCart().then(function(cart) {
      var updates = {};
      for (var i = 0; i < cart.items.length; i++) {
        if ((cart.items[i].properties || {})._bundle_id === bundleId) updates[cart.items[i].key] = 0;
      }
      if (Object.keys(updates).length > 0) {
        return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) });
      }
    }).then(function() { render(); });
  }

  function removeItem(key) {
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: { [key]: 0 } }) })
      .then(function() { render(); });
  }

  function updateItemQty(key, qty) {
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: { [key]: qty } }) })
      .then(function() { render(); });
  }

  // ============================================
  // CHECKOUT — One-Time (standard)
  // ============================================

  function handleOnetimeCheckout() {
    var btn = $('cd-btn-onetime') || $('cd-checkout');
    if (btn) { btn.disabled = true; }

    fetchCart().then(function(cart) {
      if (!cart.items || cart.items.length === 0) {
        if (btn) btn.disabled = false;
        return;
      }

      var itemsToRestore = cart.items.map(function(item) {
        var entry = { id: item.variant_id, quantity: item.quantity };
        if (item.properties && Object.keys(item.properties).length > 0) entry.properties = item.properties;
        if (item.selling_plan_allocation) entry.selling_plan = item.selling_plan_allocation.selling_plan.id;
        return entry;
      });

      var totalCans = getTotalBundleCans(cart);
      var discountCode = totalCans > 0 ? getDiscountForCans(totalCans) : '';

      return fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(function() {
          return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: itemsToRestore }) });
        })
        .then(function() {
          // Re-set ec_vid attribution after cart clear (attributes are wiped by /cart/clear.js)
          try {
            var ecVid = localStorage.getItem('ec_vid');
            if (ecVid) {
              var attrs = { ec_vid: ecVid };
              var ecVar = localStorage.getItem('ec_var');
              if (ecVar) attrs.ec_var = ecVar;
              return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attrs }) });
            }
          } catch(e) {}
        })
        .then(function() {
          // IC pixel removed — Elevar handles FB tracking (browser + CAPI with dedup)
          sessionStorage.removeItem('ec_discount_code');
          window.location.href = discountCode ? '/discount/' + encodeURIComponent(discountCode) + '?redirect=/checkout' : '/checkout';
        });
    }).catch(function() {
      if (btn) btn.disabled = false;
    });
  }

  // ============================================
  // CHECKOUT — Save with Subscription
  // ============================================

  function handleSubscriptionCheckout() {
    var btn = $('cd-btn-subscribe');
    btn.disabled = true;
    btn.querySelector('.cd-btn-subscribe__label').textContent = 'Processing...';

    fetchCart().then(function(cart) {
      if (!cart.items || cart.items.length === 0) {
        resetSubBtn();
        return;
      }

      // Group OTP bundles by _bundle_id so we can convert them
      var otpBundles = {};
      var otherItems = [];
      for (var ci = 0; ci < cart.items.length; ci++) {
        var cItem = cart.items[ci];
        var cProps = cItem.properties || {};
        if (cProps._bundle_id && cProps._otp_bundle === 'true') {
          if (!otpBundles[cProps._bundle_id]) otpBundles[cProps._bundle_id] = [];
          otpBundles[cProps._bundle_id].push(cItem);
        } else {
          otherItems.push(cItem);
        }
      }

      // Build restore list — convert one-time items to subscription
      var restorePromises = otherItems.map(function(item) {
        var props = item.properties || {};
        var entry = { id: item.variant_id, quantity: item.quantity };
        if (props && Object.keys(props).length > 0) entry.properties = props;

        if (props._bundle_id || item.selling_plan_allocation) {
          // Already subscription/bundle
          if (item.selling_plan_allocation) entry.selling_plan = item.selling_plan_allocation.selling_plan.id;
          return Promise.resolve(entry);
        }

        // One-time — try to fetch selling plan
        if (!item.url) return Promise.resolve(entry);

        return fetchProduct(item.url).then(function(product) {
          var planId = getFirstSellingPlanId(product);
          if (planId) entry.selling_plan = planId;
          return entry;
        }).catch(function() {
          return entry;
        });
      });

      return Promise.all(restorePromises).then(function(itemsToRestore) {
        // Convert OTP bundles to subscription bundles
        var otpBundleIds = Object.keys(otpBundles);
        for (var ob = 0; ob < otpBundleIds.length; ob++) {
          var obId = otpBundleIds[ob];
          var obChildren = otpBundles[obId];
          var obCans = 0;
          var obFlavorParts = [];
          for (var oc = 0; oc < obChildren.length; oc++) {
            obCans += obChildren[oc].quantity * 6;
            var fn = FLAVOR_NAMES[String(obChildren[oc].variant_id)] || obChildren[oc].variant_title;
            obFlavorParts.push(obChildren[oc].quantity + '\u00d7 ' + fn);
          }
          var obPacks = obCans / 6;
          var packOpt = BUNDLE_PACK_OPTIONS[obCans];
          if (!packOpt) packOpt = BUNDLE_PACK_OPTIONS[12]; // fallback

          // Add parent with selling plan
          itemsToRestore.push({
            id: packOpt.parentVariantId, quantity: 1,
            selling_plan: packOpt.sellingPlan,
            properties: {
              '_bundle_id': obId, '_bundle_parent': 'true',
              '_bundle_max': String(obPacks), '_bundle_min': String(obPacks),
              'Pack': obPacks + (obPacks === 1 ? ' six-pack' : ' six-packs'),
              'Flavors': obFlavorParts.join(', ')
            }
          });

          // Add children with selling plan
          for (var oc2 = 0; oc2 < obChildren.length; oc2++) {
            itemsToRestore.push({
              id: obChildren[oc2].variant_id, quantity: obChildren[oc2].quantity,
              selling_plan: packOpt.sellingPlan,
              properties: { '_bundle_id': obId }
            });
          }
        }

        // Count all bundle cans (subscription + converted OTP)
        var totalCans = getTotalBundleCans(cart);
        // Add OTP cans that are being converted
        for (var ob2 = 0; ob2 < otpBundleIds.length; ob2++) {
          var obKids = otpBundles[otpBundleIds[ob2]];
          for (var ok = 0; ok < obKids.length; ok++) totalCans += obKids[ok].quantity * 6;
        }
        var discountCode = totalCans > 0 ? getDiscountForCans(totalCans) : '';

        return fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
          .then(function() {
            return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: itemsToRestore }) });
          })
          .then(function() {
            // Re-set ec_vid attribution after cart clear (attributes are wiped by /cart/clear.js)
            try {
              var ecVid = localStorage.getItem('ec_vid');
              if (ecVid) {
                var attrs = { ec_vid: ecVid };
                var ecVar = localStorage.getItem('ec_var');
                if (ecVar) attrs.ec_var = ecVar;
                return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attrs }) });
              }
            } catch(e) {}
          })
          .then(function() {
            // IC pixel removed — Elevar handles FB tracking (browser + CAPI with dedup)
            window.location.href = discountCode ? '/discount/' + encodeURIComponent(discountCode) + '?redirect=/checkout' : '/checkout';
          });
      });
    }).catch(function() {
      resetSubBtn();
    });
  }

  function resetSubBtn() {
    var btn = $('cd-btn-subscribe');
    if (btn) {
      btn.disabled = false;
      btn.querySelector('.cd-btn-subscribe__label').textContent = 'Save with Subscription';
    }
  }

  // ============================================
  // HEADER CART BADGE
  // ============================================

  function updateBadge(count) {
    var badge = document.querySelector('.cart.j-toggle-cart span');
    if (badge) {
      if (count > 0) { badge.textContent = count; badge.style.display = ''; }
      else { badge.style.display = 'none'; }
    }
  }

  function refreshBadge() {
    fetchCart().then(function(cart) { updateBadge(cart.item_count); });
  }

  // ============================================
  // ATC INTERCEPTION (site-wide)
  // ============================================

  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form.action || form.action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var formData = new FormData(form);
    fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', body: formData })
      .then(function(res) { if (!res.ok) throw new Error('ATC failed'); return res.json(); })
      .then(function() { openDrawer(); })
      .catch(function() { form.submit(); });
  }, true);

  // ============================================
  // HEADER CART ICON INTERCEPTION
  // ============================================

  document.addEventListener('click', function(e) {
    var link = e.target.closest('.cart.j-toggle-cart, a[href="/cart"]');
    if (link) { e.preventDefault(); e.stopPropagation(); openDrawer(); }
  }, true);

  // ============================================
  // ?viewcart=true DETECTION
  // ============================================

  if (new URLSearchParams(window.location.search).has('viewcart')) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { openDrawer(); });
    } else {
      openDrawer();
    }
    history.replaceState(null, '', window.location.pathname);
  }

  // ============================================
  // INIT
  // ============================================

  function init() {
    var el;
    el = $('cd-close'); if (el) el.addEventListener('click', closeDrawer);
    el = $('cd-overlay'); if (el) el.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeDrawer(); });

    // Checkout buttons
    el = $('cd-checkout'); if (el) el.addEventListener('click', handleOnetimeCheckout);
    el = $('cd-btn-onetime'); if (el) el.addEventListener('click', handleOnetimeCheckout);
    el = $('cd-btn-subscribe'); if (el) el.addEventListener('click', handleSubscriptionCheckout);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // ============================================
  // PUBLIC API
  // ============================================

  window.CartDrawer = {
    open: openDrawer,
    close: closeDrawer,
    refresh: render,
    updateCount: refreshBadge
  };

})();
